import { ITourMainProps } from '@monofe/ui-workspace/tour/interface';
import { useEffect } from 'react';
import { injectKVStorage } from '../../interface/util';

const SHOW_DELAY_MS = 3000;

const downloadTourStateFetcher = async () => {
    const module = await import('../downloadtour/state/main');
    return module.default();
};

const _triggerPopUp = async (): Promise<void> => (await downloadTourStateFetcher()).show();

const _StorageKey = (tour: ITourMainProps): string =>
    `AutoTriggered-Download-${tour.topBar.title.text}`;

const _canTriggerPopUp = async (tour: ITourMainProps): Promise<boolean> =>
    tour.topBar.title.text.length > 0 && (await downloadTourStateFetcher()).isShowable();

const _hasShownPopUp = async (tour: ITourMainProps): Promise<boolean> =>
    (await injectKVStorage()).getItem(_StorageKey(tour)) ?? false;

const _setHasShownPopUp = async (tour: ITourMainProps): Promise<void> =>
    (await injectKVStorage()).setItem(_StorageKey(tour), true);

function DownloadAlertTrigger(tour: ITourMainProps): JSX.Element {
    useEffect(() => {
        setTimeout(async () => {
            const canShow = await _canTriggerPopUp(tour);
            const hasShown = await _hasShownPopUp(tour);

            if (canShow && !hasShown) {
                await _setHasShownPopUp(tour);
                await _triggerPopUp();
            }
        }, SHOW_DELAY_MS);
    }, [tour]);

    return <></>;
}

export default DownloadAlertTrigger;
